'use client'

import { ReactNode, useState } from 'react'
import { Text, InfoBanner } from '@vinted/web-ui'

import { CurrencyAmountModel } from '@marketplace-web/currency/currency-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent } from '@marketplace-web/bundles/items-bundle-data'

import ElectronicsVerificationModal from '../ElectronicsVerificationModal'

type Props = {
  electronicsVerificationFee?: CurrencyAmountModel | null
}

const ElectronicsVerificationBundleInfoBanner = ({ electronicsVerificationFee }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const translate = useTranslate('bundle_items')
  const { track } = useTracking()

  const handleElectronicsVerificationClick = () => {
    setIsModalOpen(true)

    track(
      clickEvent({
        screen: 'bundling',
        target: 'electronics_verification_buyer',
      }),
    )
  }

  if (!electronicsVerificationFee) return null

  const values = {
    'how-it-works': (chunks: Array<ReactNode>) => (
      <span key="how-it-works">
        <button type="button" onClick={handleElectronicsVerificationClick}>
          <Text
            clickable
            text={chunks}
            type="subtitle"
            testId="electronics-verification-info-banner-link"
            as="a"
          />
        </button>
      </span>
    ),
  }

  return (
    <>
      <InfoBanner
        testId="electronics-verification-info-banner"
        styling="tight"
        type="warning"
        body={
          <Text
            as="h3"
            text={translate('electronics_verification_note', values)}
            type="subtitle"
            theme="amplified"
          />
        }
      />
      <ElectronicsVerificationModal
        screen="bundling"
        show={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        verificationFee={electronicsVerificationFee}
        isViewingOwnItem={false}
      />
    </>
  )
}

export default ElectronicsVerificationBundleInfoBanner
